import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4f6e12b9")

_pushScopeId("data-v-4f6e12b9")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "Reset Password", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Email Address")
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = { class: "text-danger" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Reset Password")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_navbar = _resolveComponent("navbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          (_ctx.isWeb)
            ? (_openBlock(), _createBlock(_component_navbar, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, null, {
              default: _withId(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card, {
                          class: "category-card",
                          color: "dark"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_img, {
                              src: _ctx.client.logo,
                              style: {"max-width":"150px","margin":"0 auto"}
                            }, null, 8, ["src"]),
                            _hoisted_2,
                            _hoisted_3,
                            _createVNode(_component_ion_label, { position: "floating" }, {
                              default: _withId(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              style: {"border":"1px solid #fff"},
                              autocomplete: "off",
                              type: "email",
                              modelValue: _ctx.email,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
                              value: _ctx.email,
                              onIonInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.email = $event.target.value))
                            }, null, 8, ["modelValue", "value"]),
                            _hoisted_5,
                            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.error), 1),
                            _createVNode("div", _hoisted_7, [
                              _createVNode(_component_ion_button, {
                                color: "light",
                                href: "/login"
                              }, {
                                default: _withId(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                color: "light",
                                onClick: _cache[3] || (_cache[3] = () => _ctx.resetLogin())
                              }, {
                                default: _withId(() => [
                                  _hoisted_9
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})